import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { UIReducer } from '../../reducers/ui/defaultState'
import { RoomReducer } from '../../reducers/room/defaultState'
import { mediaType as MediaType } from '@bt-react/constants'
import { PlayInStatus } from '../../../lib/playIn/types'
import has from 'lodash/has'

/**
 * Determines whether the presenter is muted
 * @param state The Redux state
 */

const getMutedList = (state: State): string[] => state.syncUi.mute
const getForceMuted = (state: State): UIReducer['forcedLocalMute'] => state.ui.forcedLocalMute
const getMyBTID = (state: State, props): string => has(props, 'presenter.BTID') ? props.presenter.BTID : state.user.BTID
const getMediaType = (state: State): RoomReducer['mediaType'] => state.room.mediaType
const getPlayInStatus = (state: State): PlayInStatus => state.playIn.status
const getIgnoreRoom = (state: State, props): boolean => props.ignoreRoom

export function isMuted (
  mutedList: string[],
  BTID: string,
  forceMute: UIReducer['forcedLocalMute'],
  mediaType,
  playInStatus,
  ignoreRoom: boolean
): boolean {

  const isMuted = mutedList.includes(BTID)

  if (ignoreRoom) return isMuted

  return forceMute || isMuted || (mediaType === MediaType.PLAY_IN && playInStatus === PlayInStatus.PLAYING)

}

export default () => createSelector(
  [getMutedList, getForceMuted, getMyBTID, getMediaType, getPlayInStatus, getIgnoreRoom],
  (mutedList, forceMute, BTID, mediaType, playInStatus, ignoreRoom): boolean =>
    isMuted(mutedList, BTID, forceMute, mediaType, playInStatus, ignoreRoom)
)
